webpackJsonp([257874988357015],{

/***/ 506:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Shang-Yu Su","subtitle":"Researcher of Natural Language Processing, Information Retrieval, and Search/Recommendation Systems.","copyright":"© All rights reserved.","menu":[{"label":"About me","path":"/"},{"label":"Publications","path":"/publications/"}],"author":{"name":"Shang-Yu Su","email":"#","telegram":"#","twitter":"#","github":"#","rss":"#","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/publications/aaai2019-dstc7-avsd/","categorySlug":"/categories/dialogue/"},"frontmatter":{"title":"Reactive Multi-Stage Feature Fusion for Multimodal Dialogue Modeling","date":"2018-12-8T22:40:32.169Z","category":"Dialogue","description":"Yi-Ting Yeh, Tzu-Chuan Lin, Hsiao-Hua Cheng, Yi-Hsuan Deng, Shang-Yu Su, and Yun-Nung Chen","conference":"DSTC7"}}}]}},"pathContext":{"tag":"Visual"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-visual-8a5df3ed56c9ac80e556.js